// Theme store — light (default) / dark, persisted to localStorage.
// Applies the `dark` class to <html> so Tailwind dark: variants + the CSS
// overrides in index.css kick in.
import { create } from "zustand";
import { persist } from "zustand/middleware";

const apply = (theme) => {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
};

export const useTheme = create(
  persist(
    (set, get) => ({
      theme: "light",
      setTheme: (t) => {
        apply(t);
        set({ theme: t });
      },
      toggle: () => {
        const next = get().theme === "dark" ? "light" : "dark";
        apply(next);
        set({ theme: next });
      },
    }),
    {
      name: "iot.theme",
      onRehydrateStorage: () => (state) => {
        // Apply theme as soon as it's read back from localStorage so we
        // don't get a flash of light content on first paint.
        if (state) apply(state.theme);
      },
    }
  )
);
